export default "__VITE_ASSET__CARHfRym__"